import React, { FunctionComponent, ReactElement, useEffect, useState, } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider } from "@azure/msal-react";

// scss
import './shared/scss/main.scss';

// Components
import PageLayout from './components/PageLayout/PageLayout';
import Firmware from './components/Features/Firmware/Firmware';
import Options from './components/Features/Options/Options';
import Tune from './components/Features/Tune/Tune';

// Types and Constants
import { FEATURES, ROLE } from './shared/constants';
import FirmwareDetails from './components/Features/Firmware/FirmwareDetails.tsx/FirmwareDetails';
import TuneDetails from './components/Features/Tune/TuneDetails/TuneDetails';
import { userApi } from './api/userApi';
import { UserModel } from './shared/types';
import { UserContext } from './context/UserContext';
import Forbidden from './components/Forbidden/Forbidden';
import AssignRole from './components/Features/Users/AssignRole/AssignRole';
import Users from './components/Features/Users/Users';
import { hasCMSAccess } from './utils/auth';

type AppProps = {
  msalInstance: any;
}

const App: FunctionComponent<AppProps> = (props: AppProps): ReactElement => {
  const { msalInstance } = props;

  const [contextValue, setContextValue] = useState<any>({ user: {} as UserModel });
  const [authorized, setAuthorized] = useState<boolean>(true);

  const getUser = async () => {
    const currentUser = await userApi?.getUser();
    setAuthorized(hasCMSAccess(currentUser));
    setContextValue({ user: currentUser });
  }

  useEffect(() => {
    setTimeout(() => {
      getUser();
    }, 1000);
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <UserContext.Provider value={contextValue} >
        <PageLayout>
          <div data-testid='app-container'>
            <Routes>
              {
                authorized &&
                (
                  <>
                    <Route path='/' element={<Navigate to={`/${FEATURES.FIRMWARE}`} replace />} />
                    <Route path={`/${FEATURES.FIRMWARE}`} element={<Firmware />} />
                    <Route path={`/${FEATURES.TUNE}`} element={<Tune />} />
                    <Route path={`/${FEATURES.OPTIONS}`} element={<Options />} />
                    <Route path={`/${FEATURES.USERS}`} element={<Users />} />
                    <Route path={`/${FEATURES.FIRMWARE}/:firmwareId`} element={<FirmwareDetails />} />
                    <Route path={`/${FEATURES.TUNE}/:tuneId`} element={<TuneDetails />} />
                    <Route path={`/${FEATURES.USERS}/:assignRole`} element={<AssignRole />} />
                  </>
                )
              }

              {
                !authorized && <Route path='*' element={<Forbidden />} />
              }
            </Routes>
          </div>
        </PageLayout>
      </UserContext.Provider>
    </MsalProvider>
  );
}

export default App;
